<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Layout from './shared/Layout'

export default {
  components: {
    Layout
  },
  name: 'App',
  mounted () {
    // this.$http.defaults.headers['Authorization'] = 'Bearer ' + this.$auth.accessToken
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue